import React, { Fragment, useEffect } from "react"
import { useHtmlClassService } from "../../../../../../_metronic/layout/index.js"
import { useDispatch, useSelector } from "react-redux"
import { useState } from "react"
import * as yup from "yup"
import { useTranslation } from "react-i18next"
import { Button } from "react-bootstrap"
import { stringFormatting } from "../../../../../helpers/TextHelper.js"
import { Text2Row, SelectInput } from "../../../../../../component/index.jsx"
import { timeStampToDate } from "../../../../../helpers/DateHelper.js"
import {
  BULK_CANCEL_SCHEDULING_BUTTON,
  DATE_TYPE_ENUM
} from "../../../../../../constants/StringConstant.js"
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers/index.js"
import {
  ICON_CONSTANTS,
  ILLUSTRATION_CONSTANTS
} from "../../../../../../constants/ImageConstants.js"
import SVG from "react-inlinesvg"
import {
  clearOrderData,
  getDroneTeam,
  getInitRescheduleBulk,
  putBulkEditSchedule
} from "../../../../../../redux/actions/OrderAction.jsx"
import { MenuBack } from "../../../../../../component/atoms/MenuBack/index.jsx"
import { useHistory } from "react-router-dom"
import { CardBody } from "../../../../../../_metronic/_partials/controls/index.js"
import { FormikProvider, useFormik } from "formik"
import { Skeleton } from "@material-ui/lab"
import { toast } from "react-toastify"
import { ORDER } from "../../../../../../constants/InitTypeConstants.js"
import { Accordion } from "../../../../../../component/atoms/Expands/accordion.jsx"

export const RescheduleBulkPascaTanam = () => {
  const uiService = useHtmlClassService()
  const history = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [dataInit, setDataInit] = useState(null)
  const [stateTeam, setStateTeam] = useState([])
  const { Order, General } = useSelector((state) => state)

  useEffect(() => {
    uiService.setFullPage()
    if (Order.selectedData.length === 0) {
      history.goBack()
    } else {
      dispatch(getInitRescheduleBulk(Order.selectedData))
      dispatch(getDroneTeam())
    }
    return () => {
      dispatch(clearOrderData())
      uiService.setExitFullPage()
    }
  }, [])

  const formik = useFormik({
    initialValues: {
      area: []
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      area: yup
        .array()
        .min(1, t("messages_alert_minimum_area_required"))
        .of(
          yup.object().shape({
            team_list: yup.array().of(yup.string().required(t("messages_alert_team_required")))
          })
        )
    }),
    onSubmit: (values) => {
      const payload = values.area.map((item) => ({
        schedule_id: item.schedule_id,
        team_list: item.team_list
      }))
      dispatch(putBulkEditSchedule(payload))
    }
  })

  useEffect(() => {
    if (
      General.isFinishUpdateOrDelete &&
      !General.isError &&
      General.actionInitType === ORDER.PUT_BULK_EDIT_SCHEDULE
    ) {
      swal({
        text: t("messages_response_order_success_edit"),
        icon: toAbsoluteUrl(ILLUSTRATION_CONSTANTS.SUCCESS_EDIT_SCHEDULE),
        buttons: {
          ok: {
            text: t("button_oke"),
            className: "btn bg-primary-green text-neutral-white p-2 font-weight-normal h-100",
            value: BULK_CANCEL_SCHEDULING_BUTTON.OK
          }
        }
      }).then((status) => {
        if (status === BULK_CANCEL_SCHEDULING_BUTTON.OK) {
          history.goBack()
        }
      })
    }
  }, [General?.isFinishUpdateOrDelete])

  useEffect(() => {
    if (Order.data && Array.isArray(Order.data) && Order.data.length > 0) {
      setDataInit(Order.data)
      formik.setFieldValue(
        "area",
        Order.data?.map((item) => ({
          schedule_id: item.id,
          team_list: item.team_list.map((data) => data.team_id)
        }))
      )
      Order.data?.forEach((item, index) => {
        item.team_list.forEach((data, i) => {
          formik.setFieldValue(`area.${index}.team_list.${i}`, data.team_id)
        })
      })
    }
  }, [Order.data])

  useEffect(() => {
    if (Order.droneTeam.length) {
      setStateTeam(
        Order.droneTeam.map((value) => ({
          label: value.name + " - " + value.member,
          value: value.id
        }))
      )
    }
  }, [Order.droneTeam])

  const onChangeTeam = (e, index, i) => {
    formik.setFieldValue(`area.${index}.team_list.${i}`, e)
  }

  const onRemoveTeam = (index, i) => {
    if (formik.values.area[index].team_list.length <= 1) {
      return
    }
    const newDataInit = [...dataInit]
    newDataInit[index] = {
      ...newDataInit[index],
      team_list: newDataInit[index].team_list.filter((_, idx) => idx !== i)
    }
    setDataInit(newDataInit)
    const newTeamList = formik.values.area[index].team_list.filter((_, idx) => idx !== i)
    formik.setFieldValue(`area.${index}.team_list`, newTeamList)
  }

  const applyTeamToAll = (sourceIndex) => {
    if (!formik.values.area[sourceIndex] || !formik.values.area[sourceIndex].team_list) {
      return
    }

    const sourceAreaTeamList = formik.values.area[sourceIndex].team_list
    formik.values.area.forEach((area, index) => {
      if (index !== sourceIndex) {
        formik.setFieldValue(`area.${index}.team_list`, [...sourceAreaTeamList])
      }
    })
    toast(t("messages_alert_success_apply_drone_team_to_all_area"), {
      position: "top-center",
      autoClose: 5000,
      className: "bg-neutral-black",
      icon: <SVG src={ICON_CONSTANTS.BULLET_TICK} />,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "dark"
    })
  }

  const listFormReschedule = (
    <div className={"w-80vw mb-4"}>
      {dataInit ? (
        <h3 className={"mb-8 font-weight-bolder"}>{dataInit?.length + ` ` + t(`selected_area`)}</h3>
      ) : (
        <Skeleton animation={"wave"} variant={"text"} width={125} />
      )}
      <FormikProvider value={formik}>
        {dataInit ? (
          <Accordion
            allowMultiple={true}
            items={dataInit?.map((item, index) => ({
              header: (
                <h3 className={"w-full px-5 py-3 font-weight-bolder"}>
                  {stringFormatting(item.area_code)}
                </h3>
              ),
              content: (
                <Fragment key={index}>
                  <CardBody>
                    <div className={"row mb-8"}>
                      <div className={"col-3 mt-3"}>
                        <Text2Row
                          title={t(`label_mitra`)}
                          description={stringFormatting(item.mitra_name)}
                        />
                      </div>
                      <div className={"col-3 mt-3"}>
                        <Text2Row
                          title={t(`label_farmer`)}
                          description={stringFormatting(item.farmer_name)}
                        />
                      </div>
                      <div className={"col-3 mt-3"}>
                        <Text2Row
                          title={t(`label_activity_type`)}
                          description={`${stringFormatting(item.activity_name)}`}
                        />
                      </div>
                      <div className={"col-3 mt-3"}>
                        <Text2Row
                          title={t(`label_activity_date`)}
                          description={`${timeStampToDate(
                            item.activity_date,
                            DATE_TYPE_ENUM.ISO_DATE_STRAP
                          )} (${stringFormatting(item.hst, `HST`)})`}
                        />
                      </div>
                      <div className={"col-12 mt-3"}>
                        <Text2Row
                          title={t(`label_area_location`)}
                          description={stringFormatting(item.full_address)}
                        />
                      </div>
                    </div>
                    <h6 className={"mb-4"}>{t("label_team_drone")}</h6>
                    <div>
                      {formik.values?.area[index]?.team_list &&
                        formik.values?.area[index]?.team_list.length > 0 &&
                        formik.values?.area[index]?.team_list.map((data, i) => {
                          return (
                            <div key={i} className={"row justify-content-between flex-nowrap"}>
                              <div className={"mb-2 col"}>
                                <SelectInput
                                  key={i}
                                  name={`area.${index}.team_list.${i}`}
                                  onChange={(e) => onChangeTeam(e, index, i)}
                                  placeholder={t("placeholder_choose_drone_pilot_team")}
                                  options={stateTeam.map((itemValue) => {
                                    return {
                                      ...itemValue,
                                      isDisabled: formik.values.area[index].team_list.includes(
                                        itemValue.value
                                      )
                                    }
                                  })}
                                  withoutFeedback={false}
                                  clearNow={true}
                                  value={formik.values.area[index]?.team_list[i] || ""}
                                />
                              </div>
                              <span
                                onClick={() => onRemoveTeam(index, i)}
                                className={
                                  "svg-icon px-6 svg-icon-xl pt-2 text-center svg-icon-primary"
                                }
                                style={{ cursor: "pointer" }}>
                                {formik.values.area[index]?.team_list?.length > 1 ? (
                                  <SVG src={toAbsoluteUrl(ICON_CONSTANTS.REMOVE)} />
                                ) : (
                                  <SVG src={toAbsoluteUrl(ICON_CONSTANTS.REMOVE_OUTLINE_WHITE)} />
                                )}
                              </span>
                            </div>
                          )
                        })}
                    </div>
                    <div className={"d-flex justify-content-end align-items-center mt-4"}>
                      <div
                        className="d-flex justify-content-end align-items-center cursor-pointer mt-2 mr-3"
                        onClick={() => {
                          const newDataInit = [...dataInit]
                          newDataInit[index] = {
                            ...newDataInit[index],
                            team_list: [
                              ...newDataInit[index].team_list,
                              { team_id: "", team_name: "" }
                            ]
                          }
                          setDataInit(newDataInit)
                          const newTeamIndex = newDataInit[index].team_list.length - 1
                          formik.setFieldValue(`area.${index}.team_list.${newTeamIndex}`, "")
                        }}>
                        <SVG
                          width={20}
                          height={20}
                          src={toAbsoluteUrl(ICON_CONSTANTS.PLUS)}
                          className="ml-2 mr-3"
                        />

                        <span className={"text-info font-size-14 underline"}>
                          {t("label_add_drone_team")}
                        </span>
                      </div>
                      <div
                        className="d-flex justify-content-end align-items-center cursor-pointer mt-2"
                        onClick={() => {
                          applyTeamToAll(index)
                        }}>
                        <SVG
                          width={20}
                          height={20}
                          src={toAbsoluteUrl(ICON_CONSTANTS.APPLICATION)}
                          className="ml-2 mr-3"
                        />

                        <span className={"text-info font-size-14 underline"}>
                          {t("label_apply_to_all")}
                        </span>
                      </div>
                    </div>
                  </CardBody>
                </Fragment>
              )
            }))}
          />
        ) : null}
      </FormikProvider>
    </div>
  )

  return (
    <div>
      <div
        className={
          "bg-white d-flex justify-content-between align-content-center p-6 border-1 border-bottom border-bottom-light-dark"
        }>
        <MenuBack
          title={t("list_edit_schedule")}
          onClick={() => {
            uiService.setExitFullPage()
            history.goBack()
          }}
        />
      </div>
      <div className={"d-flex row justify-content-center w-full py-10"}>
        <div className={"w-80vw"}>
          <FormikProvider value={formik}>{listFormReschedule}</FormikProvider>
          {dataInit && (
            <div className={"d-flex justify-content-end align-items-center"}>
              <Button
                variant={"secondary"}
                onClick={() => history.goBack()}
                className={"d-flex align-items-center color-primary mr-8"}>
                {t("button_previous_kembali")}
              </Button>
              <Button
                variant={"primary"}
                onClick={() => {
                  formik.handleSubmit()
                }}
                disabled={!formik.isValid}
                className={"d-flex align-items-center color-primary py-2"}>
                {t("save_new_schedule")}
                <div className={"mx-2"}></div>
                <SVG src={toAbsoluteUrl(ICON_CONSTANTS.ARROW_RIGHT_WHITE)} />
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}